import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/display.css'
import vueCookies from 'vue-cookies'



createApp(App)  
    .use(router)
    .use(ElementPlus)
    .use(vueCookies)
    .mount('#app')